import {
	Assignment,
} from '../../models';
import {
	AssignmentFilterType,
} from './transportFilter';

/**
 * Returns an alias for a set number of locations
 * @param gln
 */
export const getAliasForGLN = (gln: string): string | undefined => {
	switch(gln) {
		case '7080004186101': return 'Moss';
		case '7080004186095': return 'Horten';
		case '7080004251113': return 'Langøya';
		default: return undefined;
	}
};

/**
 * Mutates assignments and adds the direction property
 * @param assignments
 */
export const addDirectionToAssignments = (assignments: Assignment[]): void => {
	assignments.map((assignment: Assignment) => {
		const {
			source, destination,
		} = assignment.route;

		if (getAliasForGLN(source.gln)) {
			assignment.direction = AssignmentFilterType[AssignmentFilterType.PICKUP];
			source.name = getAliasForGLN(source.gln) || source.name;
		}

		else if (getAliasForGLN(destination.gln)) {
			assignment.direction = AssignmentFilterType[AssignmentFilterType.DELIVERY];
			destination.name = getAliasForGLN(destination.gln) || destination.name;
		}

		return assignment;
	});
};